import { getEnvironment } from "~/utils/environment";

export const useEnvironment = function () {
  const url = useRequestURL();

  return getEnvironment(url);
};
